<template>
    <div>
        <div class="table-box" v-if="!course_details">
            <div class="search-box">
                <Select v-model="directionVal"
                        style="width:200px;margin-left: 10px"
                >
                    <Option value="" >全部</Option>
                    <Option :value="item.id" v-for="(item,idx) in direction_info" :key="idx">{{item.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 10px" @click="query">查询</Button>
            </div>
            <Table ref="selection" :columns="columns" :data="all_course.body" ></Table>
            <div  class="page-box" v-if="all_course.page">
                <Page show-sizer
                      show-total
                      :page-size="all_course.page.page_size"
                      :current="all_course.page.current"
                      :total="all_course.page.count"
                      @on-change="currentPage"
                      @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <div v-if="course_details">
            <course-details :course_id="course_id"></course-details>
        </div>
        <Modal
                v-model="deleteModel"
                title="删除课程"
                width="430"
                @on-ok="delCourseOk"
        >
            <p>确认删除<span style="color: #000;font-weight: 700">《{{deleteObj.course_name}}》课程吗</span>？删除后不可恢复。</p>
        </Modal>
        <Modal
                v-model="allocationModel"
                title="添加分配学院"
                width="450"
                @on-ok="ok"
        >
            <p>
                <span style="margin-right: 20px">学院名称</span>
                <Select v-model="allocationArr" multiple style="width:260px">
                    <Option :value="item.college_id" v-for="(item,idx) in colleges_info" :key="idx">{{item.name}}</Option>
                </Select>
            </p>

        </Modal>
    </div>
</template>

<script>
    import moment from 'moment'
    import courseDetails from "./courseDetails";
    import {mapActions, mapState} from 'vuex'
    export default {
        name: "toBeAllocated",
        data(){
            return{
                directionVal:'',
                course_details:false,
                allocationModel:false,
                allocationArr:[],
                deleteModel:false,
                page_size:20,
                current:1,
                course_id:null,
                deleteObj:{},
                columns:[
                    {
                        type: 'index',
                        title: '序号',
                        width:70,
                    },
                    {
                        title: '课程名称',
                        key: 'course_name'
                    },
                    // {
                    //     title: '类型',
                    //     key: 'course_nature',
                    //     width:100,
                    //     filters: [
                    //         {
                    //             label: '购买课程',
                    //             value: 2
                    //         },
                    //         {
                    //             label: '自建课程',
                    //             value: 1
                    //         }
                    //     ],
                    //     filterMultiple: false,
                    //     filterMethod (value, row) {
                    //         return row.type == value
                    //     }
                    // },
                    {
                        title: '创建人',
                        key: 'creater_name'
                    },
                    // {
                    //     title: '已分配学院',
                    //     key: 'xueyuan'
                    // },
                    {
                        title: '创建时间',
                        key: 'ctime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    // {
                    //     title: '状态',
                    //     key: 'status',
                    //     filters: [
                    //         {
                    //             label: '正常',
                    //             value: '正常'
                    //         },
                    //         {
                    //             label: '下架',
                    //             value: '下架'
                    //         }
                    //     ],
                    //     filterMultiple: false,
                    //     filterMethod (value, row) {
                    //         return row.status == value
                    //     }
                    // },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.courseDetails(params.row)
                                        }
                                    }
                                }, '查看'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                        // display:params.row.create_user == this.user_info.id? 'inline-block':'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.courseAllocation(params.row)
                                        }
                                    }
                                }, '分配课程'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                        // display:params.row.create_user == this.user_info.id? 'inline-block':'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.delCourse(params.row)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
            }
        },
        components: {
            courseDetails,
        },
        computed: {
            ...mapState({
                user_info: state => state.loginState.user_info,
                all_course: state => state.courseManage.all_course,
                direction_info: state => state.courseManage.direction_info,
                colleges_info:state => state.colleges.colleges_info
            })
        },
        methods: {
            ...mapActions({
                getCourse: 'courseManage/getCourse',
                delCurCourse:'courseManage/delCourse',
                getColleges:'colleges/getColleges',
                postAllocation:'courseManage/postAllocation'
            }),
            query(){
                let _this = this
                this.getCourse({
                    sort:'+name|-ctime',
                    page_num:_this.current,
                    page_size:_this.page_size,
                    direction:_this.directionVal,
                    is_allocation:0
                })
            },
            ok(){
                let _this = this
                this.postAllocation({
                    data:{
                        course_id:_this.course_id,
                        data:{
                            ids:_this.allocationArr
                        }
                    },
                    callback:res =>{
                        _this.$Message.success(res.message)
                        _this.getAllCourse(_this.current,_this.page_size)
                    }
                })

            },
            courseAllocation(row){
                this.allocationModel=true
                this.course_id = row.id
                this.getColleges()
            },
            delCourseOk(){
                let _this = this
                this.delCurCourse({
                    id:_this.deleteObj.id,
                    callback:res =>{
                        _this.getAllCourse(_this.current,_this.page_size)
                    }
                })
            },
            delCourse(row){
                this.deleteModel = true
                this.deleteObj = row

            },
            //查看详情
            courseDetails(row){
                this.course_details = true
                this.course_id = row.id
            },
            currentPage(num){
                this.current = num
                this.getAllCourse(num,this.page_size)
            },
            pageSizeChange(size){
                this.page_size = size
                this.getAllCourse(this.current,size)
            },
            getAllCourse(page_num,page_size){
                this.getCourse({
                    sort:'+name|-ctime',
                    page_num:page_num,
                    page_size:page_size,
                    is_allocation:0
                })
            }

        },
        mounted () {
            this.getAllCourse(this.current,this.page_size)
        },
    }
</script>

<style scoped lang="less">
    @import "../../style/index";

</style>
